import type { User } from '@/@types/user'
import { css } from '@emotion/react'
import { Fragment, type HTMLAttributes } from 'react'
import ScreenName from './ScreenName'

export interface ScreenNamesProps extends HTMLAttributes<HTMLDivElement> {
	data: User[]
}

export default function ScreenNames({ data, ...props }: ScreenNamesProps) {
	return (
		<span
			css={css`
				margin-right: 4px;
			`}
		>
			{data.map((user, index) => (
				<Fragment key={user.id}>
					<ScreenName data={user} />
					{index !== data.length - 1 && <span>、</span>}
				</Fragment>
			))}
		</span>
	)
}
